import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactGA from 'react-ga';
import { sendEmail } from '../actions/contactActions';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      message: '',
      showSentMessage: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps({ isFetching, error, data }) {
    if (this.props.isFetching && !isFetching && !error) {
      this.setState({
        name: '',
        email: '',
        message: ''
      });
    }
    if (data) {
      this.setState({ showSentMessage: true });
      setTimeout(
        function() {
          this.setState({ showSentMessage: false });
        }.bind(this),
        5000
      );
    }
  }

  handleChange(field, value) {
    this.setState({ [field]: value });
  }

  handleSubmit() {
    ReactGA.event({
      category: 'Contact Form',
      action: 'Submit'
    });
    this.props.sendEmail(this.state);
  }

  render() {
    const { error, data, isFetching } = this.props;
    const form = I18n.t('contact_page.form');
    const { placeholder_name, placeholder_email, placeholder_message } = form;

    return (
      <div id="contact-form">
        <input
          required
          type="text"
          value={this.state.name}
          placeholder={placeholder_name}
          onChange={e => this.handleChange('name', e.target.value)}
        />
        <input
          required
          type="email"
          value={this.state.email}
          placeholder={placeholder_email}
          onChange={e => this.handleChange('email', e.target.value)}
        />
        <input
          required
          type="text"
          value={this.state.message}
          placeholder={placeholder_message}
          onChange={e => this.handleChange('message', e.target.value)}
        />
        <input
          type="submit"
          value={
            isFetching
              ? 'Enviando'
              : data && this.state.showSentMessage
                ? 'Mensagem enviada!'
                : 'Enviar mensagem'
          }
          onClick={() => {
            if (!isFetching) this.handleSubmit();
          }}
        />{' '}
        {error && <span className="error">{error}</span>}
      </div>
    );
  }
}

ContactForm.propTypes = {
  isFetching: PropTypes.bool,
  error: PropTypes.string,
  data: PropTypes.object,
  sendEmail: PropTypes.func
};

const mapStateToProps = state => {
  return {
    isFetching: state.contact.isFetching,
    error: state.contact.error,
    data: state.contact.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendEmail: bindActionCreators(sendEmail, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/ContactForm.js